import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Subscriber as SubscriberComponent } from './components/subscriber';
import type { ISubscriber } from './models';

export const Subscriber = createWidget<unknown, ISubscriber>()(SubscriberComponent);
